/* unplugin-vue-components disabled */import { render } from "./bigImg.vue?vue&type=template&id=17d7c448&scoped=true"
import script from "./bigImg.vue?vue&type=script&lang=js"
export * from "./bigImg.vue?vue&type=script&lang=js"

import "./bigImg.vue?vue&type=style&index=0&id=17d7c448&scoped=true&lang=scss"
import "./bigImg.vue?vue&type=style&index=1&id=17d7c448&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d7c448"]])

export default __exports__